import FormInput from 'components/Input/FormInput';
import React, { useCallback } from 'react';
import { ValidateFields } from 'rc-field-form/es/interface';

interface ITipsCommissionPercentField {
	setTipsCommissionPercent: (value: Nullable<number>) => void;
	revalidateForm: ValidateFields;
}

const TipsCommissionPercentField: React.FC<ITipsCommissionPercentField> = ({
	setTipsCommissionPercent,
	revalidateForm,
}) => {
	// const handleChange = useCallback(
	// 	(value: Nullable<number>) => {
	// 		setTipsCommissionPercent(value);
	// 		revalidateForm(['tipsCommissionMaxValue']);
	// 	},
	// 	[setTipsCommissionPercent, revalidateForm],
	// );

	return (
		<FormInput
			testId="TipsCommissionPercentField"
			type="number"
			min={0}
			max={100}
			precision={0}
			name="tipsCommissionPercent"
			label="tipsCommissionPercentLabel"
			onChangeNumber={setTipsCommissionPercent}
		/>
	);
};

export default React.memo(TipsCommissionPercentField);
